/**
 * @file CardFeatured/constants.js
 * @copyright 2017 CBC/Radio-Canada. All rights reserved.
 * @author Fitore Jaha [fitore.jaha@cbc.ca]
 */

export const DEFAULT_IMAGE_SIZES = [
    "(max-width: 731px) 98vw",
    "(max-width: 1280px) 55vw",
    "640px",
];
